import { Component, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColDef } from 'ag-grid-community';
import { ApiService } from '../../shared/services/api.service';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  standalone: false,
  styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  content: any;
  type = 'currency';
  apiUrl: any;

  columnDefs: ColDef[] = [
        {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-outline-primary', 'ps-4', 'pe-4', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'Name',
      field: 'name',
      editable: false,
      filter: true,
      width: 250
    },
    {
      headerName: 'Short Name',
      field: 'shortName',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Symbol',
      field: 'symbol',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    },

  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private zone: NgZone
  ) { }

  ngOnInit(): void {

  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {

      vm.gridApi.sizeColumnsToFit();
    }
    this.gridApi.sizeColumnsToFit();
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        vm.apiUrl = '/partners/auth/get-data?type=' + vm.type + '&_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  addNew(content: any) {
    const vm = this;
    vm.dataObj = {};
    //this.content = content;
    vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'lg' });
  }

  onEdit(data: any) {
    this.zone.run(() => {
      this.dataObj = data.data;
      this.modalRef = this._modal.open(this.content, { backdrop: 'static', size: 'lg' });
    });
  }

  setContent(c: any) {
    this.content = c;
  }

  onSubmit(flag: any) {
    this.dataObj['type'] = this.type;
    const apiUrl = this.dataObj._id ? '/partners/auth/edit-data' : '/partners/auth/new-data';
    this._api.postData(apiUrl, this.dataObj).subscribe((res: any) => {
      if (res && !res.error) {
        this.onClose();
        this.gridApi.refreshInfiniteCache();
      }
    });
  }

  onClose() {
    this.modalRef.close();
  }

}
